"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFixedRateSampler = void 0;
var CryptoJS = _interopRequireWildcard(require("crypto-js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Hashes a telemetry ID and maps it to a value between 0 and 1.
 *
 * @param id - The telemetry ID to hash.
 * @returns A number between 0 and 1 based on the hash value.
 */
const hashTelemetryId = id => {
  const hash = CryptoJS.SHA256(id).toString(CryptoJS.enc.Hex);
  return Number.parseInt(hash.slice(0, 8), 16) / 0xffffffff;
};
/**
 * Creates a fixed-rate sampler function to determine if telemetry should be kept
 * based on a hash of its ID and a specified sampling rate.
 *
 * @param samplingRate - Sampling rate as a percentage (e.g., 10 for 10%, 1 for 1%).
 * @returns A sampler function that takes an optional telemetry ID and returns `true` if the telemetry is kept, `false` otherwise.
 */
const createFixedRateSampler = percentage => {
  // Convert percentage to a decimal sampling rate
  const samplingRate = percentage / 100;

  /**
   * Sampler function to decide whether to include telemetry based on its ID.
   *
   * @param id - The telemetry ID (e.g., operation ID or custom data ID). If `undefined`, a random fallback is used.
   * @returns `true` if the telemetry should be kept, `false` otherwise.
   */
  return id => {
    if (!id) {
      return Math.random() < samplingRate; // Fallback for missing IDs
    }
    const hashValue = hashTelemetryId(id);
    return hashValue < samplingRate; // Include if hash value is within the sampling rate
  };
};
exports.createFixedRateSampler = createFixedRateSampler;
